import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import CryptoService from "../../../services/crypto-service.js";
import StatusBadge from '../../common/helper/transaction-status.component.js';


const ViewCrypto = () => { 
  const userData = useSelector(state => state.authReducer);
const [crypto, setCrypto] = useState({});
const [loading, setLoading] = useState(false);
const { id } = useParams();
const navigate = useNavigate()
const handleDownload = (image) => {
  window.open(image, '_blank');
};
    const getMerchant = () => {
        setLoading(true);
        CryptoService.viewCrypto(id)
              .then(response => {
                const data =response.data.data
                setCrypto(data)
                setLoading(false);
              })
              .catch(error => {
                setLoading(false);
                try {
                  const errorMessage = error.response.data
                  toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                } catch (e){
                  toast.error( MESSAGES.SERVER_ERROR)
                }
              });
      }
    useEffect(() => {
    
        getMerchant();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
const back = () => {
  
  const hasPermission = useUserPermissionData('crypto_admin');
  if(hasPermission) {
    navigate('/crypto?userType='+crypto.user_type.toLowerCase()); 
  } else {
    navigate(-1)
  }
}
const useUserPermissionData = (userData,permcode) => {
  
  if (!userData || !userData.data || !userData.data.role || !userData.data.role.permissions)
      return false;

  const permissionArr = userData.data.role.permissions;
  return permissionArr.some(permission => permission.permission_code === permcode);
}
return(
  <div>
  <LoaderOverlay loading={loading} />
  <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
  <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>View Crypto Details</h4>
  <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Crypto Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MERCHANT ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.merchant_id ? merchant.merchant_detail.merchant_id : '-'}</p>
                </div> */}
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Order ID</label>
                  <p>{crypto.order_id}</p>
                </div>
              </div>
              {( ConfigService.checkUserPermission('crypto_admin')) && (
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Name</label>
                  <p>{crypto.name}</p>
                </div>
              </div>
              )}
              {crypto && crypto.user_type == 'AGENT' && (
                <>
                <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Agent Code</label>
                  <p>{crypto.agent_code}</p>
                </div>
              </div>
                </>
              )}
              {crypto && crypto.request_type == 'S' && (
                <>
                <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Type</label>
                  <p>Sell</p>
                </div>
              </div>
                </>
              )}
                 {crypto && crypto.request_type == 'B' && (
                <>
                <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Type</label>
                  <p>Buy</p>
                </div>
              </div>
                </>
              )}
              
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">BUSSINESS TYPE ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.business_type_id ? merchant.merchant_detail.business_type_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Requested Quantity</label>
                  <p>₹{crypto.requested_quantity || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATUS ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.status_id ? merchant.merchant_detail.status_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Approved Quantity</label>
                  <p>{crypto.approved_quantity || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISSION GROUP NAME</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.comm_grp_name ? merchant.merchant_detail.comm_grp_name : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Requested Rate</label>
                  <p>{crypto.requested_rate || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Approved Rate</label>
                  <p>{crypto.approved_rate || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Status</label>
                  <p> <StatusBadge status={crypto.status} /></p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">User Type</label>
                  <p>{crypto.user_type}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Created On</label>
                  <p>{crypto.created_on || '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {crypto && crypto.details && (
        <>
        <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
                <a className="nav-link active_tab1" id="list_per_details">Details</a>
            </li>
            </ul>
            <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
                <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                    <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                    {crypto && crypto.details.map((record, index) => ( 
                        <>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Exchange</label>
                        <p>{record.exchange}</p>
                        </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                       
                        {crypto && crypto.request_type == 'S' && (
                          <>
                           <label htmlFor="f_name">Transaction Id</label>
                          <p>{record.transaction_id || '-'}</p>
                          </>
                              )}
                              {crypto && crypto.request_type == 'B' && (
                          <>
                           <label htmlFor="f_name">Address</label>
                          <p>{record.address || '-'}</p>
                          </>
                              )}
                        </div>
                  
                    </div>
                    {record.qr_code_url && (
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">{record.exchange} Image</label>
                      <img style={{marginLeft: '2px',cursor:'pointer'}} onClick={() => handleDownload(record.qr_code_url)} className="image-preview vjk" src={record.qr_code_url}></img>
                      
                        </div>
                    </div>
                    )}
                    </>
                    ))}
                    </div>
                </div>
                </div>
            </div>
            </div>
            
        </>
    )}

{crypto && crypto.approvals && crypto.approvals.length > 0 &&(
        <>
        <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
                <a className="nav-link active_tab1" id="list_per_details"> Approval Details</a>
            </li>
            </ul>
            <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
                <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                    <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                    {crypto && crypto.approvals.map((record, index) => ( 
                        <>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Exchange</label>
                        <p>{record.exchange}</p>
                        </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Transaction Id</label>
                        <p>{record.transaction_id || '-'}</p>
                        </div>
                    </div>
                    {record.screenshot_url && (
                      <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">{record.exchange} ScreenShot</label>
                    <img style={{marginLeft: '2px',cursor:'pointer'}} onClick={() => handleDownload(record.screenshot_url)} className="image-preview vjk" src={record.screenshot_url}></img>

                      </div>
                    </div>
                    )}
                  
                    </>
                    ))}
                    </div>
                </div>
                </div>
            </div>
            </div>
            
        </>
    )}
   

    <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-success backbt">Back</button></a>
  </div>
</div>
</div>

)

} 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(ViewCrypto));